import { MoneyConnectClientAPI, RetryableMoneyConnectClientAPI } from "./axios-service-creator";

export const AuthAPI = {
  oAuth: (payload) => RetryableMoneyConnectClientAPI.post("/authen/oauth/signIn/token", payload),
  oAuthFundTrans: (payload) => RetryableMoneyConnectClientAPI.post("/authen/oauth/signIn/fundsTrans", payload),
  oAuthPWM: (payload) => RetryableMoneyConnectClientAPI.post("/authen/oauth/signIn/pwm", payload),
  signIn: (payload) => RetryableMoneyConnectClientAPI.post("/authen/auth/signIn", payload),
  signInPrivateWealthManagement: (payload) => MoneyConnectClientAPI.post("/authen/pwm/token", payload),
  signInPrivateWealthManagementNew: (payload) => MoneyConnectClientAPI.post("/consolidate/pwm/info", payload),
  signInResearchPage: () => MoneyConnectClientAPI.get("/research/news"),
  signInPWM: (payload) => MoneyConnectClientAPI.post("/consolidate/pwm/getAppEntry", payload),
  signOut: () => MoneyConnectClientAPI.post("/authen/auth/signOut"),
  checkEnableLogin: () => MoneyConnectClientAPI.get("/common/master/enableLogin"),
};
